"use client"

import * as React from "react"
import { useRouter } from "next/navigation"
import { Languages } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useTranslation } from "@/components/app/i18n-provider"
import { locales, type Locale } from "@/lib/i18n/settings"
import {getLocaleName} from "@/lib/i18n/locale-names";

export function LocaleToggle() {
    const { t, locale } = useTranslation()
    const router = useRouter()

    async function switchLocale(newLocale: Locale) {
        if (newLocale === locale) return

        await fetch("/api/locale", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ locale: newLocale }),
        })

        router.refresh()
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger render={<Button variant="outline" size="icon" />}>
    <Languages className="size-4" />
    <span className="sr-only">{t("language.toggle")}</span>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
        {locales.map((loc) => (
                <DropdownMenuItem
                    key={loc}
            className={cn(loc === locale && "bg-accent text-accent-foreground")}
    onClick={() => switchLocale(loc)}
>
    {getLocaleName(loc, locale)}
    </DropdownMenuItem>
))}
    </DropdownMenuContent>
    </DropdownMenu>
)
}
